import { Component } from '@angular/core';
import { BehaviorSubject, debounceTime } from 'rxjs'; 
import { NzModalRef } from 'ng-zorro-antd/modal'; 
import LoginModel from '../../models/user.model';
import { AppCommon } from '../../providers/app-common';
import { TaskReportResponseModel } from '../../models/report.model';
import { CostApprovalViewModel } from '../../models-views/cost-approval.view.model';
import { UserResponseModel } from '../../models/task.model';

@Component({
  selector: 'app-add-cost-approval',
  standalone: false,
  templateUrl: './add-cost-approval.component.html',
  styleUrl: './add-cost-approval.component.scss',
  providers: [CostApprovalViewModel]
})
export class AddCostApprovalComponent {
  
    taskListData = new BehaviorSubject<TaskReportResponseModel>(new TaskReportResponseModel());
    userListData = new BehaviorSubject<UserResponseModel>(new UserResponseModel());
  
    constructor(private modalRef: NzModalRef, private vm: CostApprovalViewModel) { 
       this.loginModel.next(AppCommon.getloggedInObject());
    }
   
    searchChange$ = new BehaviorSubject('');
    optionList: any[] = [];
    selectedTask?: number;
    selectedUser?: number;
    comment?: string = '';
    loading = false;
    loginModel = new BehaviorSubject<LoginModel>(new LoginModel());
  
    ngOnInit(): void {
      this.vm.parentAddCostApprovalComponent = this;
      this.vm.subscribeToTaskList(this.taskListData);
      this.vm.userListData.subscribe(this.userListData);
      this.vm.getUsers();
      this.searchChange$.pipe(debounceTime(500)).subscribe(name => this.vm.getTaskList(name));
      
    } 
    
    onSearch(value: string): void {
      this.loading = true;
      this.searchChange$.next(value);
    }
  
    getTaskList(name: string) {
      this.vm.getTaskList(name);
    }
  
    taskDataReceived(){
      this.optionList = this.taskListData.value.results;
      this.loading = false;
    }
   
    close(): void {
      this.modalRef.close(false);
    }
  
    create(): void {
      this.vm.createCostApprovalProcess(
        this.selectedUser,
        this.selectedTask,
        this.comment,
        this.loginModel.value.user.id
      );
    }
  
    costApprovalCreated(){
      this.modalRef.close(true);
    }
    
}
